import { useMemo } from 'react';
import { usersToOptions } from '../utils/usersToOptions';
import { useRoutableUsers } from './useRoutableUsers';
export const useRoutableUserOptions = props => {
  const {
    error,
    loading,
    refetch,
    refetching,
    users
  } = useRoutableUsers(props);
  const userOptions = useMemo(() => {
    if (Array.isArray(users)) {
      return usersToOptions(users);
    }
    return [];
  }, [users]);
  return {
    error,
    loading,
    refetch,
    refetching,
    userOptions
  };
};